import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useGetFinances = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.cash.balance],
    queryFn: () =>
      cashService.finances().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
